// src/services/categoryService.js
import { authFetch } from "../utils/api";

export const createCategory = async (categoryData) => {
    const dataToSend = { ...categoryData };
    delete dataToSend.userId;
    delete dataToSend.user_id;

    try {
        // ⭐ Utilisation de .post(url, body)
        const response = await authFetch.post('/categories', dataToSend);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || "Échec de la création de la catégorie.");
        }

        return response.json();
    } catch (error) {
        console.error("❌ Erreur dans createCategory:", error);
        throw error;
    }
};

export const updateCategory = async (categoryId, categoryData) => {
    const dataToSend = { ...categoryData };
    delete dataToSend.userId;
    delete dataToSend.user_id;
    
    try {
        // ⭐ Utilisation de .put(url, body)
        const response = await authFetch.put(`/categories/${categoryId}`, dataToSend);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || "Échec de la modification de la catégorie.");
        }
        return response.json();
    } catch (error) {
        console.error("❌ Erreur dans updateCategory:", error);
        throw error;
    }
};